// 手机号正则
// const phone = /^((13[0-9])|(14[5,7,9])|(15([0-3]|[5-9]))|(166)|(17[0,1,3,5,6,7,8,9])|(18[0-9])|(19[8|9]))\d{8}$/;
const phone = /^1\d{10}$/;
const starPhone = /^[0-9][0-9*]{9}[0-9]$/;

// 手机号
var checkPhone = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('手机号不能为空'));
    } else {
        if (phone.test(value)) {
            callback();
        } else {
            return callback(new Error('手机号格式不正确'));
        }
    }
};
// 手机号(可为空)
var checkedPhone = (rule, value, callback) => {
    if (!value) {
        callback();
    } else {
        if (phone.test(value)) {
            callback();
        } else {
            return callback(new Error('手机号格式不正确'));
        }
    }
};
// 带星手机号
var checkStarPhone = (rule, value, callback) => {
    if (!value) {
        callback();
    } else {
        if (phone.test(value) || starPhone.test(value)) {
            callback();
        } else {
            return callback(new Error('手机号格式不正确'));
        }
    }
};
// 正整数
var checkPositiveInt = (rule, value, callback) => {
    if (!value) {
        return callback();
    } else {
        var reg = /^[1-9][0-9]*$/
        if (reg.test(value)) {
            callback();
        } else {
            return callback(new Error('格式不正确,请输入正整数'));
        }
    }
};

// 数字
var checkNumber = (rule, value, callback) => {
    if (!value) {
        return callback();
    } else {
        var reg = /^[0-9]+$/
        if (reg.test(value)) {
            callback();
        } else {
            return callback(new Error('格式不正确'));
        }
    }
};

// 金额
var checkmoney = (rule, value, callback) => {
    if (!value) {
        return callback();
    } else {
        var a = /^[1-9][0-9]{0,7}(\.[0-9]{0,2})?$/
        var b = /^[0-9](\.[0-9]{0,2})?$/
        if (a.test(value) || b.test(value)) {
            callback();
        } else {
            return callback(new Error('金额格式不正确'));
        }
    }
};
// 邮箱
var checkEmail = (rule, value, callback) => {
    if (!value) {
        return callback();
    } else {
        var reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
        if (reg.test(value)) {
            callback();
        } else {
            return callback(new Error('邮箱格式不正确'));
        }
    }
};
// 网址
var checkUrl = (rule, value, callback) => {
    if (!value) {
        return callback();
    } else {
        var reg = /^https:\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]*com[-A-Za-z0-9+&@#/%?=~_|!:,.;]*$/
        if (reg.test(value)) {
            callback();
        } else {
            return callback(new Error('请输入正确网址'));
        }
    }
};


export default {
    phone,  //手机号正则规则
    starPhone,  //带星手机号正则规则
    checkPhone, // 手机号
    checkedPhone,   //手机号(可为空)
    checkStarPhone, //带星手机号
    checkEmail, //邮箱
    checkmoney, //金额
    checkNumber, //数字
    checkPositiveInt, //正整数
    checkUrl,   //网址
}


// WEBPACK FOOTER //
// ./src/assets/validateRules.js